'use client'

import { useUTMPersistence } from '@/hooks/useUTMPersistence'

/**
 * UTM Persistence Component
 *
 * This component should be included in the root layout to automatically
 * handle UTM parameter persistence across all pages in the application.
 *
 * It will:
 * 1. Capture UTM parameters when a user first lands on any page
 * 2. Store them in sessionStorage
 * 3. Apply them to subsequent page URLs during the session
 * 4. Make them available for form submissions
 */
export default function UTMPersistence() {
  // This hook handles all the UTM persistence logic
  useUTMPersistence()

  // This component doesn't render anything visible
  return null
}
